export default "__VITE_ASSET__NUoAKlhQ__"